export class PhoneVerificationRequestModel {
    userId: string | null = null;
    phoneNumber: string | null = null;

    constructor(data?: Partial<PhoneVerificationRequestModel>) {
        Object.assign(this, data);
    }
}
